import { Icon } from '@zapier/zinnia-icons';
import { useContext } from 'react';

import { Button, ComboBoxStateContext } from 'react-aria-components';

import { TypeaheadProps } from './Typeahead';
import { useTypeaheadContext } from './TypeaheadContext';
import styles from './TypeaheadRightSlot.module.scss';

type TypeaheadRightSlotProps = {
  isTypeaheadDisabled?: boolean;
  size: TypeaheadProps['size'];
};

/**
 * A component for a button to clear the `Typeahead` selection in the input,
 * as well as display an icon on the right side of the input if set.
 */
export const TypeaheadRightSlot = ({
  isTypeaheadDisabled = false,
  size,
}: TypeaheadRightSlotProps) => {
  const { markExplicitClear } = useTypeaheadContext();
  const state = useContext(ComboBoxStateContext);
  const showClearSelectionButton = state?.inputValue && !isTypeaheadDisabled;

  const getIconSize = () => {
    if (size === 'compact') return '16px';
    if (size === 'large') return '24px';

    // Default to medium size icon.
    return '20px';
  };

  return showClearSelectionButton ? (
    <div className={styles.iconButtonWrapper} data-size={size} data-zds>
      {/* DS-3076 will replace this custom button with an DS IconButton component */}
      <Button
        aria-label="Clear selection"
        className={styles.clearButton}
        data-size={size}
        data-zds
        onPress={() => {
          markExplicitClear();
          state?.setSelectedKey(null);
        }}
        // Don't inherit default RAC Button behavior from RAC ComboBox.
        slot={null}
      >
        <Icon
          className={styles.icon}
          name="arrowRefresh"
          color="StrokeStronger"
          size={getIconSize()}
        />
      </Button>
    </div>
  ) : null;
};
